import { render, staticRenderFns } from "./ResetPasswordIcon.vue?vue&type=template&id=1f527102&scoped=true"
import script from "./ResetPasswordIcon.vue?vue&type=script&lang=js"
export * from "./ResetPasswordIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f527102",
  null
  
)

export default component.exports